import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { mapState } from 'vuex';
import { fetchTemplateList } from '@/api/dmaker/template';
import { fetchTemplateVersion, changeVersionName, deleteTemplateVersion } from '@/api/dmaker/custom';
import _ from 'lodash';

export default {
  props: ['getSaveLoading', 'saveConfirm'],
  components: {},
  data: function data() {
    return {
      app_id: 0,
      template_id: 0,
      isActiveNum: 0,
      isCurrentNum: 0,
      list: [],
      listNew: []
    };
  },

  methods: {
    hover: function hover(e, item) {
      if (e.path && e.path[0].clientWidth >= e.path[0].scrollWidth) {
        // 超出
        this.$set(item, 'showtoop', true);
      } else {
        this.$set(item, 'showtoop', false);
      }
    },
    showInputTest: function showInputTest(childer) {
      var _this = this;

      var blue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$set(childer, 'showInput', !childer['showInput']);

                if (blue) {
                  _context.next = 5;
                  break;
                }

                // ref控制v-if元素时有生命周期问题，详见官方文档
                setTimeout(function () {
                  _this.$refs.inputInfo[0].focus();
                }, 0);
                _context.next = 8;
                break;

              case 5:
                // 修改名字
                data = {
                  id: childer.id,
                  name: childer.name
                };
                _context.next = 8;
                return changeVersionName(data);

              case 8:
                _this.change();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    change: function change() {
      this.$forceUpdate();
    },
    handleClick: function handleClick(item) {
      item.visible = !item.visible;
    },
    handleVersionAdd: function handleVersionAdd(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var loading;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading = _this2.getSaveLoading();
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.saveTemplate();

              case 4:
                _context2.next = 6;
                return _this2.getTemplateInfo();

              case 6:
                _this2.$emit('create', item);
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);

              case 12:
                loading.close();

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9]]);
      }))();
    },
    handleCopy: function handleCopy(item, template, type) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var tempItem, loading;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tempItem = _extends({}, template, {
                  copy_id: item.id,
                  copy_name: item.name
                });
                loading = _this3.getSaveLoading();
                _context3.prev = 2;
                _context3.next = 5;
                return _this3.saveTemplate();

              case 5:
                _context3.next = 7;
                return _this3.getTemplateInfo();

              case 7:
                // type: multi-custom或dco
                _this3.$emit('copy', { params: tempItem, type: type });
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](2);

                console.log(_context3.t0);

              case 13:
                _this3.getTemplateListNew();
                loading.close();

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 10]]);
      }))();
    },
    handleChoose: function handleChoose(template, item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var loading;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loading = _this4.getSaveLoading();
                _context4.prev = 1;
                _context4.next = 4;
                return _this4.saveTemplate();

              case 4:
                _this4.$router.push({
                  path: '' + _this4.getCustomPath(template.template_id) + item.id
                });
                _this4.$message({
                  type: 'success',
                  message: _this4.$t('playTurbo.common.versionBar.switchSuccess')
                });
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](1);

                console.log(_context4.t0);

              case 11:
                loading.close();

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 8]]);
      }))();
    },
    saveTemplate: function saveTemplate() {
      return this.$store.dispatch('creative/template/saveTemplate');
    },
    getTemplateInfo: function getTemplateInfo() {
      return this.$store.dispatch('creative/template/getTemplateInfo');
    },
    handleCommand: function handleCommand(command, item, template) {
      if (command === 'delete') {
        this.handleDelete(item);
      } else if (command === 'download') {
        this.$emit('download', item, template);
      } else if (command === 'copy-to-multi-custom') {
        this.handleCopy(item, template, 'multi-custom');
      } else if (command === 'copy-to-dco') {
        this.handleCopy(item, template, 'dco');
      } else {
        this.handleCopy(item, template);
      }
    },
    handleDelete: function handleDelete(item) {
      var _this5 = this;

      if (item.id === this.isActiveNum) {
        this.$message({
          type: 'warning',
          message: this.$t('playTurbo.common.versionBar.deleteForbidden')
        });
        return;
      }
      this.$confirm(this.$t('playTurbo.common.versionBar.deleteConfirm.content'), this.$t('playTurbo.common.versionBar.deleteConfirm.title'), {
        confirmButtonText: this.$t('playTurbo.common.versionBar.deleteConfirm.confirmButtonText'),
        cancelButtonText: this.$t('playTurbo.common.versionBar.deleteConfirm.cancelButtonText'),
        type: 'warning'
      }).then(function () {
        _this5.deleteVersion(item.id);
      });
    },
    setTemplateId: function setTemplateId() {
      // 除以1是将templateId转换为Number
      this.template_id = Number(this.$route.params.templateId);
    },
    getTemplateListNew: function getTemplateListNew() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var post, res, list;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.setTemplateId();
                post = {
                  is_optimiz: 1,
                  ctype: 'normal'
                };
                _context5.next = 4;
                return fetchTemplateList(post);

              case 4:
                res = _context5.sent;
                list = _.get(res, 'data.data.list');

                _this6.listNew = list;
                _this6.setAppid(list, _this6.template_id);

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    deleteVersion: function deleteVersion(customId) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var deleteRequest, res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                deleteRequest = function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(data) {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            return _context6.abrupt('return', deleteTemplateVersion(data));

                          case 1:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this7);
                  }));

                  return function deleteRequest(_x2) {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context7.next = 3;
                return deleteRequest({ custom_id: customId });

              case 3:
                res = _context7.sent;

                if (Number(_.get(res, 'data.code')) === 0) {
                  _this7.$message({
                    type: 'success',
                    message: _this7.$t('playTurbo.common.versionBar.deleteSuccess')
                  });
                  _this7.getTemplateListNew();
                  _this7.setisActiveNum();
                }

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },

    // 传入产品模板二级列表，根据模板id查询归属产品id,添加版本列表
    setAppid: function setAppid(list, templateId) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var req, childerlist;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (templateId) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt('return');

              case 2:
                // 根据类型使用不用请求接口
                req = function req() {
                  return fetchTemplateVersion({
                    template_id: templateId,
                    creator: 'myself'
                  });
                };

                _context8.t0 = _;
                _context8.next = 6;
                return req();

              case 6:
                _context8.t1 = _context8.sent;
                childerlist = _context8.t0.get.call(_context8.t0, _context8.t1, 'data.data.list');

                list.findIndex(function (value) {
                  var istemplate = (value.templates || []).findIndex(function (value) {
                    if (value.template_id === templateId) {
                      _this8.$set(value, 'childer', childerlist.filter(function (item) {
                        return item.status === 1;
                      }));
                    }
                    return value.template_id === templateId;
                  });
                  if (istemplate !== -1) {
                    _this8.app_id = value.app_id;
                  }
                });
                console.log(_this8.$refs.templatename[0], 1);

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    getAppIdByTemplateId: function getAppIdByTemplateId(list, templateId) {
      var appId = '';
      list.forEach(function (item) {
        var hasTemplateId = (item.templates || []).filter(function (el) {
          return el.template_id === Number(templateId);
        }).length > 0;
        if (hasTemplateId) {
          appId = item.app_id;
        }
      });
      return appId;
    },
    getCustomPath: function getCustomPath(templateId) {
      return '/creative-service/playable/' + templateId + '/custom/';
    },

    // 点击请求模板列表
    addtemplatechilder: function addtemplatechilder(templateId) {
      this.setAppid(this.listNew, templateId);
    },
    setisActiveNum: function setisActiveNum() {
      this.isActiveNum = Number(this.$route.params.customId);
    }
  },
  computed: _extends({}, mapState({
    customId: function customId(state) {
      return state.creative.custom.id;
    },
    page: function page(state) {
      return state.creative.template.page;
    }
  })),
  watch: {
    $route: function $route() {
      this.getTemplateListNew();
    }
  },
  mounted: function mounted() {
    this.getTemplateListNew();
    this.setisActiveNum();
    this.isCurrentNum = Number(this.$route.params.templateId);
  }
};